import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { IImage } from '@homeporter/types';

import { useCanvasSketchContext } from '../../contexts/CanvasSketchContext';
import { useInspectorStyles } from '../../pages/VirtualSession/styles';

interface ICanvasImageProps {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  selectedImage: IImage | null;

  setIsImageLoading: (isLoading: boolean) => void;
  selectedImageElement: HTMLImageElement | null;
  strokesLayer: number;
  rotation: number;
}

const CanvasImage = ({
  canvasRef,
  selectedImage,
  setIsImageLoading,
  selectedImageElement,
  strokesLayer,
  rotation,
}: ICanvasImageProps) => {
  const styles = useInspectorStyles();

  const { setStrokeList } = useCanvasSketchContext();

  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);

  const [canvasSketchSize, setCanvasSketchSize] = useState<{
    width: number;
    height: number;
  }>({ width: 0, height: 0 });

  useEffect(() => {
    const canvasImage = canvasRef?.current;
    const ctx = canvasImage?.getContext('2d');
    const img = selectedImageElement;

    console.log('img:', img);

    if (!ctx || !canvasImage?.parentElement) {
      console.log('::::ctx or canvasImage?.parentElement is not found');
      return;
    }

    if (!img) {
      ctx.clearRect(0, 0, canvasImage.width, canvasImage.height);
      canvasImage.width = 0;
      canvasImage.height = 0;
      setDimensions(null);
      return;
    }

    const bounds = canvasImage.parentElement.getBoundingClientRect();
    if (!bounds) return;

    console.log(
      `::::CanvasImage image is loaded img.width: ${img.width} x  img.height: ${img.height}`,
      bounds,
    );

    const imgWidth =
      rotation === 90 || rotation === -90 ? img.height : img.width; //need to consider 270, -270
    const imgHeight =
      rotation === 90 || rotation === -90 ? img.width : img.height;

    setDimensions({ width: imgWidth, height: imgHeight });
    const sx = bounds.width / imgWidth;
    const sy = bounds.height / imgHeight;
    const s = Math.min(sx, sy);

    const canvasWidth = Math.round(s * imgWidth);
    const canvasHeight = Math.round(s * imgHeight);

    console.log(
      `canvasImage.width: ${canvasImage.width} width: ${canvasWidth} canvasImage.height: ${canvasImage.height} height: ${canvasHeight}`,
    );

    console.log('draw selectedImage to CanvasImage..');

    console.log(`set canvasImage size to ${canvasWidth} X ${canvasHeight}`);
    setCanvasSketchSize({ width: canvasWidth, height: canvasHeight });
    canvasImage.width = canvasWidth;
    canvasImage.height = canvasHeight;

    setTimeout(() => {
      ctx.save();
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);

      // Center of canvas for transform origin
      ctx.translate(canvasWidth / 2, canvasHeight / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.scale(s, s);

      // Move image so its center aligns with canvas center after transform
      if (rotation === 90 || rotation === -270) {
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
      } else if (rotation === -90 || rotation === 270) {
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
      } else if (rotation === 180 || rotation === -180) {
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
      } else {
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
      }

      ctx.restore();
      setIsImageLoading(false);
    }, 100);

    let strokes: any[] = [];
    if (selectedImage?.strokes)
      try {
        strokes = selectedImage.strokes[strokesLayer];
        if (!Array.isArray(strokes)) strokes = [strokes];
      } catch (e) {}

    console.log('strokes:', strokes);
    setStrokeList([...strokes]);
  }, [selectedImage, strokesLayer, selectedImageElement, canvasRef, rotation]);

  return (
    <>
      <canvas
        ref={canvasRef}
        width={canvasSketchSize.width}
        height={canvasSketchSize.height}
        style={{
          ...(styles.screenshot as React.CSSProperties),
          backgroundColor: 'rgba(255, 255, 0, .2)',
        }}
      />
      {dimensions && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            color: '#fff',
            padding: '.25rem .5rem',
            borderRadius: '.25rem',
            fontSize: '.75rem',
            fontFamily: 'monospace',
            zIndex: 1,
          }}>
          {dimensions.width} × {dimensions.height}
        </Box>
      )}
    </>
  );
};

export default CanvasImage;
